<template>
  <div class="noni_scartchcard container-fluid">
    <form id="noni_gift_form" method="post" @submit.prevent v-if="!sent">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <p v-if="country_selection">
                <label>
                  {{ country_label }}* <br />
                  <select
                    class="select-css"
                    v-model="gift.country"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="country"
                  >
                    <option
                      :value="country.code"
                      v-for="country in countries"
                      :key="country.code"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                  <span :class="{ invalid: errors.has('country') }" class="danger">{{
                    errors.first("country")
                  }}</span>
                </label>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <p>
                <label>
                  {{ first_name_label }}* <br />
                  <input
                    v-model="gift.first_name"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="first_name"
                  />
                  <span :class="{ invalid: errors.has('first_name') }" class="danger">{{
                    errors.first("first_name")
                  }}</span>
                </label>
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <label>
                  {{ last_name_label }}* <br />
                  <input
                    v-model="gift.last_name"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="last_name"
                  />
                  <span :class="{ invalid: errors.has('last_name') }" class="danger">{{
                    errors.first("last_name")
                  }}</span>
                </label>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <p>
                <label>
                  {{ email_label }}* <br />
                  <input
                    v-model="gift.email"
                    v-validate="'required|email'"
                    ref="email"
                    data-vv-validate-on="blur"
                    type="email"
                    name="email"
                  />
                  <span :class="{ invalid: errors.has('email') }" class="danger">{{
                    errors.first("email")
                  }}</span>
                </label>
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <label>
                  {{ confirm_email_label }}* <br />
                  <input
                    v-model="gift.confirm_email"
                    v-validate="'required|confirmed:email'"
                    ref="confirm_email"
                    data-vv-validate-on="blur"
                    type="email"
                    name="confirm_email"
                  />
                  <span
                    :class="{ invalid: errors.has('confirm_email') }"
                    class="danger"
                    >{{ errors.first("confirm_email") }}</span
                  >
                </label>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <p>
                <label>
                  {{ cell_label }}* <br />

                  <select
                    id="cell-area"
                    v-model="gift.area_code"
                    name="cell-area"
                    class="select-css"
                  >
                    <option
                      :value="country.dial_code"
                      v-for="country in countries"
                      :key="country.code"
                    >
                      {{ country.name }} {{ country.dial_code }}
                    </option>
                  </select>
                </label>
              </p>
            </div>
            <div class="col-md-8">
              <p>
                <label>
                  <span class="invisible">number</span><br/>
                  <input
                    id="cell-main"
                    v-model="gift.cell"
                    v-validate="'required|integer'"
                    data-vv-validate-on="blur"
                    name="cell"
                    type="text"
                  />
                  <span :class="{ invalid: errors.has('cell') }" class="danger">{{
                    errors.first("cell")
                  }}</span>
                  </label>
              </p>
            </div>
          </div>
         <div class="row">
          <div class="col-md-12">
             <p>
                <label>
                  {{ product_label }}* <br />
                  <select
                    v-if="products.length > 0"
                    class="select-css"
                    v-model="gift.product"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="product"
                  >
                    <option
                      v-for="product in products"
                      :key="product.id"
                      :value="product.product"
                    >
                      {{ product.product }}
                    </option>
                  </select>
                  <input
                    v-else
                    v-model="gift.product"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="product"
                  />
                  <span :class="{ invalid: errors.has('product') }" class="danger">{{
                    errors.first("product")
                  }}</span>
                </label>
              </p>
          </div>
         </div>
          <div class="row">
            <div class="col-md-6">
              <p>
                <label>
                  {{ code_label }}* <br />
                  <input
                    v-model="gift.code"
                    v-validate="'required'"
                    name="code"
                    data-vv-validate-on="blur"
                    type="text"
                    pattern="\b[a-zA-Z0-9]{12}\b"
                  />
                  <span :class="{ invalid: errors.has('code') }" class="danger">{{
                    errors.first("code")
                  }}</span>
                </label>
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <label>
                  {{ method_label }}* <br />
                  <select name="cf-subject" v-model="gift.method" class="select-css">
                    <option value="text" v-if="nexmo_enabled">Text</option>
                    <option value="email">Email</option>
                  </select>
                </label>
              </p>
              <p class="noni-center">
                <button
                  class="noni-scratchcard-submit btn primary btn-lg"
                  @click="send()"
                  :disabled="loading"
                >
                  <span v-if="loading"> Sending </span>
                  <span v-else> Send </span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div v-show="sent" class="noni-message" ref="message">
      <h3>Your prize has been sent!</h3>
    </div>
  </div>
</template>

<script>
var Qs = require("qs");
import Swal from "sweetalert2";
import CONSTANTS from "../constants";
export default {
  name: "GiftForm",
  data: () => ({
    loading: false,
    gift: {
      message: "Hello Vue!",
      email: "",
      confirm_email: "",
      first_name: "",
      last_name: "",
      cell: "",
      code: "",
      product: "",
      user_ref: null,
      action: "gift_form_submission",
      method: "email",
      area_code: "+1",
      country: "US",
    },

    widget: null,
    form: null,
    button: null,
    sent: false,
    country_selection: true,
    countries: CONSTANTS.COUNTRIES,

    email_label: "Email",
    confirm_email_label: "Confirm Email",
    first_name_label: "First Name",
    last_name_label: "Last Name",
    cell_label: "Cell",
    code_label: "Scratch Card Code",
    product_label: "Which product did you purchase?",
    method_label: "How do we send you your prize?",
    country_label: "Country",
    products: [],
  }),
  mounted: function () {
    this.getProducts();
    this.axios
      .get(
        "https://api.ipdata.co?api-key=05ac003d8a8be6675badabe27f1e726c6925a6ffb611ce0abcf2f7db"
      )
      .then((response) => {
        this.gift.country = response.data.country_code;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  watch: {
    "gift.country": function (val) {
      if (val == "DE") {
        this.setGerman();
      } else {
        this.setEnglish();
      }
    },
  },
  computed: {
    // a computed getter
    nexmo_enabled: function () {
      // `this` points to the vm instance
      return window.ajax_object.nexmo_enabled == "true";
    },
  },

  methods: {
    getProducts() {
      this.axios
        .post(
          window.ajax_object.ajax_url,
          Qs.stringify({
            action: "noni_get_products_public",
            ajax_nonce: window.ajax_object.ajax_nonce,
          })
        )
        .then((response) => response.data)
        .then((response) => {
          this.products = response;
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: "An error occurred",
            type: "error",
          });
          console.log(error);
        })
        .finally(() => {});
    },
    setEnglish() {
      this.$validator.localize("en", {
        attributes: {
          email: "Email",
          first_name: "First Name",
          last_name: "Last Name",
          cell: "Cell",
          code: "Code",
          product: "Product",
          method: "Delivery Method",
          country: "Country",
        },
      });

      this.email_label = "Email";
      this.confirm_email_label = "Confirm Email";
      this.first_name_label = "First Name";
      this.last_name_label = "Last Name";
      this.cell_label = "Cell";
      this.code_label = "Scratch Card Code";
      this.product_label = "Which product did you purchase?";
      this.method_label = "How do we send you your prize?";
      this.country_label = "Country";
    },
    setGerman() {
      this.$validator.localize("de", {
        attributes: {
          email: "E-Mail-Adresse",
          first_name: "Vorname",
          last_name: "Nachname",
          cell: "Telefonnummer",
          code: "Code",
          product: "Produkt",
          method: "Zustellungsmethode",
          country: "Land",
        },
      });

      this.email_label = "E-Mail-Adresse";
      this.confirm_email_label = "Confirm E-Mail-Adresse";
      this.first_name_label = "Vorname";
      this.last_name_label = "Nachname";
      this.cell_label = "Telefonnummer";
      this.code_label = "Code";
      this.product_label = "Produkt";
      this.method_label = "Zustellungsmethode";
      this.country_label = "Land";
    },
    send() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.loading = true;

          var request = {
            message: this.gift.message,
            email: this.gift.email,
            first_name: this.gift.first_name,
            last_name: this.gift.last_name,
            cell: parseInt(this.gift.area_code + this.gift.cell),
            code: this.gift.code,
            product: this.gift.product,
            user_ref: this.gift.user_ref,
            action: this.gift.action,
            method: this.gift.method,
            country: this.gift.country,
            ajax_nonce: window.ajax_object.ajax_nonce,
          };

          this.axios
            .post(window.ajax_object.ajax_url, Qs.stringify(request))
            .then((response) => {
              if (response.data.success == true) {
                this.sent = true;
                var element = this.$refs["message"];
                var top = element.offsetTop;
                window.scrollTo(0, top);
              } else {
                Swal.fire({
                  title: "Error",
                  text: response.data.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.errored = true;
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          Swal.fire({
            title: "Error",
            text: "The form is invalid",
            type: "error",
          });
        }
      });
    },
  },
};
</script>
